import { render } from "./BaseImage.vue?vue&type=template&id=b6cefa8c"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__